import React from 'react';

type SafetyPageProps = {
  onRestart: () => void;
};

export function SafetyPage({ onRestart }: SafetyPageProps) {
  return (
    <div className="stage-shell">
      <div className="stage-frame stage-frame--centered">
        <header className="stage-header">
          <div className="stage-brand" style={{ textAlign: 'left' }}>
            GuidesCollective
          </div>
          <div className="stage-header-placeholder" />
        </header>
        <div className="stage-main" style={{ alignItems: 'center', textAlign: 'center' }}>
          <div className="stage-icon" aria-hidden>
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#1f2937"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 3l7 3v6c0 5-3.5 9-7 9s-7-4-7-9V6l7-3z" />
              <path d="M10.5 11.5l1.5 1.5 3-3" />
            </svg>
          </div>
          <div className="stage-copy">
            <h1 className="stage-title">Safety &amp; Security</h1>
            <p className="stage-description">
              Thanks for completing your onboarding details. We�ll keep everything secure while we
              find Guides who fit you best.
            </p>
          </div>
        </div>
        <footer className="stage-footer">
          <button className="stage-primary" onClick={onRestart}>
            Return to start
          </button>
        </footer>
      </div>
    </div>
  );
}